import { ref, withParams } from 'vuelidate/lib/validators/common';
import moment from 'moment';

export default minDateValue => withParams(
  { type: 'minDateValue', eq: minDateValue },
  function (value, parentVm) {
    const other = ref(minDateValue, this, parentVm);
    if (other && value) {
      const otherM = moment(other);
      const valM = moment(value);
      otherM.startOf('day');
      valM.startOf('day');
      return valM.diff(otherM) >= 0;
      // return value.getTime() > other.getTime()
    }
    return false;
  },
);
